import { render, staticRenderFns } from "./StickyHeaderMobile.vue?vue&type=template&id=4f4d88fd&scoped=true"
import script from "./StickyHeaderMobile.vue?vue&type=script&lang=ts"
export * from "./StickyHeaderMobile.vue?vue&type=script&lang=ts"
import style0 from "./StickyHeaderMobile.vue?vue&type=style&index=0&id=4f4d88fd&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f4d88fd",
  null
  
)

export default component.exports